import {
  Companion_instance1xjg859pd52fi as Companion_instance,
  _Result___init__impl__xyqfz823vatsdepqb9n as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  Result__exceptionOrNull_impl_p6xea9318j6pdzpd0vd as Result__exceptionOrNull_impl_p6xea9,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { pipelineStartCoroutineUninterceptedOrReturn3fvxhza76tp2 as pipelineStartCoroutineUninterceptedOrReturn } from './PipelineJs.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Key_instancesrycfl6s632h as Key_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/ContinuationInterceptor.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineDispatcher.mjs';
import { recoverStackTraceBridge1qu82j8ymuquf as recoverStackTraceBridge } from './StackTraceRecover.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from './PipelineContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function loop($this, direct) {
  do {
    var currentIndex = $this.c4t_1;
    if (currentIndex === $this.x4s_1.q2()) {
      if (!direct) {
        // Inline function 'kotlin.Companion.success' call
        var value = $this.z4s_1;
        var tmp$ret$0 = _Result___init__impl__xyqfz8(value);
        resumeRootWith($this, tmp$ret$0);
        return false;
      }
      return true;
    }
    $this.c4t_1 = currentIndex + 1 | 0;
    var next = $this.x4s_1.r2(currentIndex);
    try {
      var result = pipelineStartCoroutineUninterceptedOrReturn(next, $this, $this.z4s_1, $this.y4s_1);
      if (result === get_COROUTINE_SUSPENDED())
        return false;
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(cause));
        resumeRootWith($this, tmp$ret$1);
        return false;
      } else {
        throw $p;
      }
    }
  }
   while (true);
}
function resumeRootWith($this, result) {
  // Inline function 'kotlin.check' call
  if (!($this.b4t_1 >= 0)) {
    var message = 'No more continuations to resume';
    throw IllegalStateException().o(toString(message));
  }
  var next = ensureNotNull($this.a4t_1[$this.b4t_1]);
  var _unary__edvuaz = $this.b4t_1;
  $this.b4t_1 = _unary__edvuaz - 1 | 0;
  $this.a4t_1[_unary__edvuaz] = null;
  var interceptor = next.mc().yc(Key_instance);
  var tmp;
  if (interceptor instanceof CoroutineDispatcher()) {
    tmp = interceptor.m12(next.mc()) ? intercepted(next) : next;
  } else {
    tmp = intercepted(next);
  }
  var toResume = tmp;
  var exception = Result__exceptionOrNull_impl_p6xea9(result);
  if (exception == null) {
    toResume.oc(result);
  } else {
    var recoveredException = recoverStackTraceBridge(exception, next);
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(recoveredException));
    toResume.oc(tmp$ret$3);
  }
}
function discardLastRootContinuation($this) {
  // Inline function 'kotlin.check' call
  if (!($this.b4t_1 >= 0)) {
    var message = 'No more continuations to resume';
    throw IllegalStateException().o(toString(message));
  }
  var _unary__edvuaz = $this.b4t_1;
  $this.b4t_1 = _unary__edvuaz - 1 | 0;
  $this.a4t_1[_unary__edvuaz] = null;
}
var SuspendFunctionGun$continuation$1Class;
function SuspendFunctionGun$continuation$1() {
  if (SuspendFunctionGun$continuation$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.e4t_1 = this$0;
        this.d4t_1 = -2147483648;
      }
      mc() {
        var inductionVariable = this.e4t_1.b4t_1;
        if (0 <= inductionVariable)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var cont = this.e4t_1.a4t_1[index];
            if (!(cont === this) && !(cont == null))
              return cont.mc();
          }
           while (0 <= inductionVariable);
        // Inline function 'kotlin.error' call
        var message = 'Not started';
        throw IllegalStateException().o(toString(message));
      }
      sk(result) {
        // Inline function 'kotlin.onFailure' call
        var tmp0_safe_receiver = Result__exceptionOrNull_impl_p6xea9(result);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.Companion.failure' call
          var tmp$ret$4 = _Result___init__impl__xyqfz8(createFailure(tmp0_safe_receiver));
          resumeRootWith(this.e4t_1, tmp$ret$4);
          return Unit_instance;
        }
        loop(this.e4t_1, false);
      }
      oc(result) {
        return this.sk(result);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Continuation()]);
    SuspendFunctionGun$continuation$1Class = $;
  }
  return SuspendFunctionGun$continuation$1Class;
}
var SuspendFunctionGunClass;
function SuspendFunctionGun() {
  if (SuspendFunctionGunClass === VOID) {
    class $ extends PipelineContext() {
      constructor(initial, context, interceptors) {
        super(context);
        this.x4s_1 = interceptors;
        var tmp = this;
        tmp.y4s_1 = new (SuspendFunctionGun$continuation$1())(this);
        this.z4s_1 = initial;
        var tmp_0 = this;
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.x4s_1.q2();
        tmp_0.a4t_1 = Array(size);
        this.b4t_1 = -1;
        this.c4t_1 = 0;
      }
      sv() {
        return this.y4s_1.mc();
      }
      p4r() {
        return this.z4s_1;
      }
      *r4r($completion) {
        // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
        return yield () => {
          var tmp0 = $completion;
          var tmp$ret$1;
          $l$block_0: {
            if (this.c4t_1 === this.x4s_1.q2()) {
              tmp$ret$1 = this.z4s_1;
              break $l$block_0;
            }
            this.f4t(tmp0);
            if (loop(this, true)) {
              discardLastRootContinuation(this);
              tmp$ret$1 = this.z4s_1;
              break $l$block_0;
            }
            tmp$ret$1 = get_COROUTINE_SUSPENDED();
          }
          return tmp$ret$1;
        };
      }
      *q4r(subject, $completion) {
        this.z4s_1 = subject;
        return yield* this.r4r($completion);
      }
      *s4r(initial, $completion) {
        this.c4t_1 = 0;
        if (this.c4t_1 === this.x4s_1.q2())
          return initial;
        this.z4s_1 = initial;
        // Inline function 'kotlin.check' call
        if (!(this.b4t_1 < 0)) {
          var message = 'Already started';
          throw IllegalStateException().o(toString(message));
        }
        return yield* this.r4r($completion);
      }
      f4t(continuation) {
        this.b4t_1 = this.b4t_1 + 1 | 0;
        this.a4t_1[this.b4t_1] = continuation;
      }
    }
    initMetadataForClass($, 'SuspendFunctionGun', VOID, VOID, VOID, [0, 1]);
    SuspendFunctionGunClass = $;
  }
  return SuspendFunctionGunClass;
}
//region block: exports
export {
  SuspendFunctionGun as SuspendFunctionGun278ui80hj12zj,
};
//endregion

//# sourceMappingURL=SuspendFunctionGun.mjs.map
